import isEmpty from 'lodash/isEmpty';
import defaultsDeep from 'lodash/defaultsDeep';
import {
    BB_BETFEED_ENABLED_STATE_KEY,
    BB_BETFEED_WIDGET_ENABLED_STATE_KEY,
    BB_BETFEED_FILTER_TYPE_SPORTS,
    BB_BETFEED_FILTER_BET_TYPES_DEFAULT,
    BB_BETFEED_FILTER_SELECTED_KEY,
    BB_BETFEED_FILTER_MOST_RECENT,
    BB_BETFEED_WIDGET_BETFEED_URL,
    I18N_PREFIX,
} from '../constants';

import { getState } from '../../../shared/utils/state';

export const DATE_FORMAT = /^(\d{4})-?(\d{1,2})-?(\d{0,2})(.*?(\d{1,2}):(\d{1,2}):(\d{1,2}))?.?(\d{1,3})?$/;

/**
 * Parse the given parameter to Date object
 * @param {(object|string|null|undefined)} date for parsing
 * @return {Date} date object
 */
export const parseDate = (date) => {
    let reg;
    if (date === null) {
        return new Date(NaN); // null as an invalid date
    } else if (typeof date === 'undefined'){
        return new Date();
    } else if (date instanceof Date) {
        return date;
    } else if (typeof date === 'string' && (reg = date.match(DATE_FORMAT))) {
        return new Date(
            reg[1], reg[2] - 1, reg[3] || 1, // eslint-disable-line no-magic-numbers
            reg[5] || 0, reg[6] || 0, reg[7] || 0, reg[8] || 0 // eslint-disable-line no-magic-numbers
        );
    }

    return new Date(date);
};

export const isBetfeedPageEnabled = () => Boolean(getState(BB_BETFEED_ENABLED_STATE_KEY));

export const isBetfeedWidgetEnabled = () => Boolean(getState(BB_BETFEED_WIDGET_ENABLED_STATE_KEY));

/**
 * Return the 'reset filters' state for selected filters
 * @see filtersSet()
 * @param {string} filter type of filter to reset
 * @returns {object} reset 'selected' filters object
 */
export const getResetSelectedFilters = (filter) => {
    if(filter && filter === BB_BETFEED_FILTER_TYPE_SPORTS.id) {
        return { sports: {} };
    }

    return {
        sports: {},
        betType: BB_BETFEED_FILTER_BET_TYPES_DEFAULT,
        eventStatus: BB_BETFEED_FILTER_BET_TYPES_DEFAULT,
    };
};

/**
 * Check if filters have been applied
 * @param {object} selected the current filter.selected props
 * @see initialState in initialState.js and getResetSelectedFilters() above
 * @returns {boolean} true|false
 */
export const filtersSet = (selected) => {
    return !(isEmpty(selected.sports) && isEmpty(selected.betType) && isEmpty(selected.eventStatus));
};

export const toName = (str) => {
    return str.replace(/(^|-|_)(\w)/g, function (matches, preMark, letter) {
        return `${preMark ? ' ': ''}${letter.toUpperCase()}`;
    });
};

export const getDefaultSelectedFilters = () => {
    const selectedLocalStorage = JSON.parse(localStorage.getItem(BB_BETFEED_FILTER_SELECTED_KEY));

    const defaultSelected = {
        sports: {},
        eventStatus: BB_BETFEED_FILTER_BET_TYPES_DEFAULT,
        betType: BB_BETFEED_FILTER_BET_TYPES_DEFAULT,
        sortBy: BB_BETFEED_FILTER_MOST_RECENT,
    };

    const { pathname, search } = window.location;

    if(pathname === BB_BETFEED_WIDGET_BETFEED_URL && search) {
        const selected = {};
        const filterNames = Object.keys(defaultSelected);
        search.replace(/([^?=&]+)=([^&]*)?/g, function ( $0, filter, value ) {
            if (value && filterNames.includes(filter)) {
                const id = value.toLowerCase();
                if (filter === BB_BETFEED_FILTER_TYPE_SPORTS.id) {
                    selected[filter] = {};
                    for (const sport of id.split(',')) {
                        if (sport) {
                            selected[filter][sport] = { name: toName(sport) };
                        }
                    }
                } else {
                    selected[filter] = { id, name: `${I18N_PREFIX}.${id}` };
                }
            }
        });
        if (Object.keys(selected).length) {
            return defaultsDeep(selected, defaultSelected);
        }
    }

    if(selectedLocalStorage) {
        return defaultsDeep(selectedLocalStorage, defaultSelected);
    }

    return defaultSelected;
};
